import React from "react";
import { Col, Row } from "react-bootstrap";
import ListCardEvents from "../ListCardEvents";
import { ContentActivities, useStyles } from "../Activities/Activities.styled";
import { theme as themeConfig } from "../../themes/themes";
import PointersLine from "../Loaders/PointersLine/PointersLine";
import PropTypes from "prop-types";
import PaginationComponent from "../PaginationComponent/PaginationComponent";

const Activities = ({
  loadingAllPublicEventList,
  errorAllPublicEventList,
  events,
  rowsPerPage,
  rowsPerPageOptions,
  page,
  allPages,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  const longEvents = events?.length;
  const classes = useStyles({
    longEvents,
  });
  return (
    <ContentActivities>
      <Row className={classes.containEvents}>
        <Col md={12} className={classes.bodyEvents}>
          {(loadingAllPublicEventList && !errorAllPublicEventList) && (
            <Row>
              <Col
                md="12"
                className="d-flex justify-content-center align-content-center my-5"
              >
                <PointersLine color={themeConfig.text.primary} />
              </Col>
            </Row>
          )}
          {(!loadingAllPublicEventList && errorAllPublicEventList) && (
            <Row>
              <Col
                md="12"
                className="d-flex justify-content-center align-content-center my-5"
              >
                <h1 style={{ color: themeConfig.neutral.gray[900] }}>Error :(</h1>
              </Col>
            </Row>
          )}
          {(!loadingAllPublicEventList && !errorAllPublicEventList) && (
            <Row className={classes.rowContainEvents}>
              {events?.length > 0 &&
                events.map((event) => (
                  <ListCardEvents
                    key={event.idEvent}
                    idEvent={event.idEvent}
                    eventTitle={event.eventTitle}
                    speakerName={event.speakerName}
                    jobPosition={event.jobPosition}
                    startDate={event.startDate}
                    startTime={event.startTime}
                    endTime={event.endTime}
                    attendees={event.attendees}
                    language={event.language}
                    urlPhoto={event.urlPhoto}
                    description={event.description}
                    createUser={event.createUser}
                    isFull={event.isFull}
                    recurrenceEndDate={event.recurrenceEndDate}
                    recurrencePattern={event.recurrencePattern}
                  />
                ))}
            </Row>
          )}
          {allPages > 0 && rowsPerPage && rowsPerPageOptions && (
            <PaginationComponent
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={rowsPerPageOptions}
              totalItems={allPages}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          )}
        </Col>
      </Row>
    </ContentActivities>
  );
};

Activities.propTypes = {
  loadingAllPublicEventList: PropTypes.bool,
  errorAllPublicEventList: PropTypes.bool,
  events: PropTypes.array,
  rowsPerPage: PropTypes.number,
  rowsPerPageOptions: PropTypes.array,
  allPages: PropTypes.number,
  page: PropTypes.number,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func,
};

export default Activities;
